import svgd from './svgd/index'

class SvgD {
  constructor(svg) {
    let s = new svgd(svg)
    this.update = s.update.bind(s)
  }
}

export default SvgD


// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/dinnerSvg/index.js